<template>
  <div>
    <span @click="openWelcomePopup()" class="cursor-pointer"></span>
    <welcome-popup></welcome-popup>
    <render-popup
      :roleId="roleId"
      :displayRep="displayRep"
      :playNextTour="playNextTour"
      :previousTour="previousTour"
      :currentTour="currentTour"
      :tourObjectLength="tourObject.length"
      :tourIndex="tourIndex"
    ></render-popup>
    <account-settings-popup
      :previousTour="previousTour"
      :tourlength="tourObject.length"
    ></account-settings-popup>
    <success-popup></success-popup>
  </div>
</template>
<script>
import $ from 'jquery';
import WelcomePopup from './WelcomePopup.vue';
import RenderPopup from './RenderPopup.vue';
import AccountSettingsPopup from './AccountSettingsPopup.vue';
import { getRamsTour } from '../../apis/dashboard';
import SuccessPopup from './SuccessPopup.vue';
import EventBus from '../../utils/event-bus';

export default {
  components: {
    WelcomePopup,
    RenderPopup,
    AccountSettingsPopup,
    SuccessPopup
  },
  props: ['displayRep'],
  data() {
    return {
      roleId: 0,
      tourIndex: 0,
      displayTour: false,
      currentTour: {},
      tourObject: [
        {
          key: 0,
          type: 'Dashboard',
          title: 'Central hub to manage your company’s data',
          content:
            '<ul class="item-container"><li>Browse updates and RA/QA news in your RAMS Headlines</li><li>Customize with your company updates (see Account Settings for details)</li><li>Immediately access all RAMS features</li></ul>',
          url: '/layout/dashboard',
          image: '/static/images/icons/dashboard_icon.svg',
          clickValue: 10
        },
        {
          key: 1,
          type: 'Marketplace',
          title: 'Flexible solutions for your business',
          content:
            '<ul><li>Explore powerful RA/QA resources to grow and manage your complex business</li><li>Flexible subscription options to maximize resources</li><li>Purchase a premium service, then navigate through the taskbar to improve how your company manages regulatory affairs</li></ul>',
          url: '/layout/market-place',
          clickValue: 56,
          image: '/static/images/icons/marketplace_icon.svg'
        },
        {
          key: 2,
          type: 'Notifications',
          title: 'Smarter solutions for managing regulatory affairs',
          content:
            '<ul><li>Keep your team informed</li><li>At-a-glance updates to track deadlines critical for your business</li><li>Syncs with your company’s data on RAMS</li></ul>',
          url: '/layout/alert',
          clickValue: 101,
          image: '/static/images/icons/bell_icon.svg'
        },
        {
          key: 3,
          type: 'Smart Docs',
          title: 'Centralize Your RA/QA Documentation',
          content:
            '<ul><li>Store your documentation in a one spot to make them easier to locate</li><li>Upload documents to share with team members</li><li>RAMS security features keep your data safe</li></ul>',
          url: '/layout/smart-docs',
          clickValue: 151,
          image: '/static/images/icons/smart_docs.svg'
        },
        {
          key: 4,
          type: 'Resources',
          title: 'Explore global RA/QA resources',
          content:
            '<ul><li>Exploring a specific market? Quickly locate RAMS resources and services that help</li><li>Immediate access to regulations and guidances</li><li>Estimate costs and historical data for expanding your business</li></ul>',
          url: '/layout/resourcesdashboard',
          clickValue: 195,
          image: '/static/images/icons/resources_icon.svg'
        },
        {
          key: 5,
          type: 'Regulations & Guidances',
          title: 'Global resources at your fingertips',
          content:
            '<ul><li>Immediately locate requirements for more than 40 markets</li><li>Save time finding the information your business needs</li><li>Regularly updated by Emergo by UL’s team of industry experts</li></ul>',
          url: '/layout/regsandguidance',
          clickValue: 232
        },
        {
          key: 7,
          type: 'Tools',
          title: 'Free with your RAMS subscription',
          content:
            '<ul><li>Estimate approval time required for your next FDA 510(k)</li><li>FDA Product Classification Lookup saves time searching for information</li><li>Government Fee Finder identifies government filing costs when expanding into new markets</li></ul>',
          url: '/layout/tools',
          clickValue: 267
        },
        {
          key: 8,
          type: 'Representation Resources',
          title: 'Exclusive to in-country representation clients',
          content:
            '<ul><li>Instant access to templates, checklists, cheat sheets, and more</li><li>Download individual documents or select all items for that market</li><li>Easily customize  templates to your needs</li></ul>',
          url: '/layout/representationresources',
          clickValue: 242
        },
        {
          key: 9,
          type: 'Smart Exchange',
          title: 'Easily manage your RA/QA projects',
          content:
            '<ul><li>Quickly and easily track progress of your regulatory affairs projects</li><li>Immediately identify which elements of your project are complete and which are still outstanding</li><li>Includes definitions for what needs to be included in each element of your project</li></ul>',
          url: '/layout/smart-exchange',
          clickValue: 300,
          image: '/static/images/icons/smartexchange_icon.svg'
        },
        {
          key: 10,
          type: 'Product Classification',
          title: 'Unlock new markets, download key insights',
          content:
            '<ul><li>Quickly determine or verify device classification</li><li>Download valuable reports to guide device strategy</li><li>Flexible service options to access expert support specific to your device and situation</li></ul>',
          url: '/layout/prodclassification',
          clickValue: 345,
          image: '/static/images/icons/prod_classification_icon.svg'
        },
        {
          key: 11,
          type: 'Regulatory Reports',
          title: 'Global vision to scale your business',
          content:
            '<ul><li>Go-to resource for understanding how regulatory bodies operate in each country</li><li>Locate requirements and resources for in-country representation, importers, and distributors</li><li>Avoid costly business interruptions and stay on market post-approval</li></ul>',
          url: '/layout/regulatory-pathway',
          clickValue: 385,
          image: '/static/images/icons/reg_pathway_icon.svg'
        },
        {
          key: 12,
          type: 'Smart Builder',
          title: 'Easy and efficient regulatory documents',
          content:
            '<ul><li>Reduce time-consuming errors that derail regulatory approval</li><li>Intuitive tools walk you through approval for multiple markets</li><li>Improve your team’s collaboration</li><li>Generate professional documents aligned with governing body standards</li></ul>',
          url: '/layout/submission-builder',
          clickValue: 425,
          image: '/static/images/icons/submission_icon.svg'
        },
        {
          key: 13,
          type: 'Registration Tracker',
          title: 'Automated tool to control business',
          content:
            '<ul><li>Save time and avoid headaches with automated tracking</li><li>Focus on your business rather than tracking changes to regulatory markets</li><li>Get “big picture” data insights in one simple graphic</li><li>Instantly share information with teammates</li></ul>',
          url: '/layout/trackplusdashboard',
          clickValue: 470,
          image: '/static/images/icons/track_plus_icon.svg'
        },
        {
          key: 14,
          type: 'Regulatory Watch',
          title: 'Instant access to global RA experts',
          content:
            '<ul><li>Get the latest updates on regulations and guidance</li><li>Customize your feed to the markets that affect your business</li><li>Choose from global updates or narrow your newsfeed to key markets</li><li>Flag important updates, archive items, and take control of regulatory updates</li></ul>',
          url: '/layout/regulatory-updates',
          clickValue: 510,
          image: '/static/images/icons/reg_alerts_icon.svg'
        },
        {
          key: 15,
          type: 'Regulatory Intelligence',
          title: 'Chart a course for regulatory approval',
          content:
            '<ul><li>Download at-a-glance market planning tools</li><li>Immediate answers to market access questions</li><li>Get targeted insights on key markets</li><li>Simplifies complex requirements</li></ul>',
          url: '/layout/regulatoryprocesscharts',
          clickValue: 560,
          image: '/static/images/icons/reg_intel_icon.svg'
        },
        {
          key: 16,
          type: 'Training & Compliance',
          title: 'Ensure compliance with UL ComplianceWire<sup style="font-size: 20px">®</sup>',
          content:
            '<ul><li>Best-in-class validated Part 11 LMS</li><li>Learning solution used by the US FDA</li><li>Automate the administration of regulatory compliance</li></ul>',
          url: '/layout/market-place/service/8',
          clickValue: 605,
          image: '/static/images/icons/cw.svg'
        },
        {
          key: 17,
          type: 'Quality Management System (eQMS)',
          title: 'eQMS built for medical device industry',
          content:
            '<ul><li>Integrated design controls, risk management, and quality process</li><li>Flexible review and approval workflows</li><li>Update your risk management file and avoid costly rework</li><li>Help your business remain audit-ready at all times</li></ul>',
          url: '/layout/market-place/service/5',
          clickValue: 665,
          image: '/static/images/icons/gg_icon.svg'
        }
      ]
    };
  },
  methods: {
    openWelcomePopup() {
      $('#modal_welcome').modal({
        backdrop: 'static',
        keyboard: false,
        show: true
      });
    },
    playNextTour() {
      this.tourIndex += 1;
      if (this.tourIndex === this.tourObject.length) {
        $('#modal_dashboard').modal('hide');
        this.currentTour = { type: 'Account Settings' };
        EventBus.$emit('openDrpDwnAccount');
        $('#modal_accounts').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        this.currentTour = this.tourObject[this.tourIndex];
        EventBus.$emit('highlightNav', this.currentTour.url);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Virtual tour',
        stage: this.currentTour.type
      });
    },
    previousTour() {
      this.tourIndex -= 1;
      if (this.tourIndex === -1) {
        $('#modal_dashboard').modal('hide');
        this.currentTour = {};
        EventBus.$emit('closeMobileSideBar');
        this.openWelcomePopup();
      } else if (this.tourIndex === this.tourObject.length - 1) {
        $('#modal_dashboard').modal({
          backdrop: 'static',
          keyboard: false
        });
        $('#modal_accounts').modal('hide');
        EventBus.$emit('closeDrpDwnAccount');
      } else {
        this.currentTour = this.tourObject[this.tourIndex];
        EventBus.$emit('highlightNav', this.currentTour.url);
      }
    }
  },
  async mounted() {
    this.roleId = JSON.parse(localStorage.getItem('roleId'));
    const response = await getRamsTour();
    this.displayTour = sessionStorage.getItem('displayTour');
    sessionStorage.removeItem('displayTour');
    groove.widget.close();
    EventBus.$on('displayTour', () => {
      this.openWelcomePopup();
    });
    if ((response && response.new_user) || this.displayTour) this.openWelcomePopup();
    if (!this.displayRep) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Representation Resources');
      for (let i = 0; i < this.tourObject.length; i += 1) {
        const obj = this.tourObject[i];
        if (obj.type === 'Tools') {
          obj.clickValue = '267';
        }
        if (obj.key >= 9) {
          obj.clickValue -= 60;
        }
      }
    }
    if (this.roleId === 6) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Smart Builder');
    }
    if (this.roleId === 3 || this.roleId === 6) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Smart Docs');
    }
    if (this.roleId === 6 || this.roleId === 4) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Smart Exchange');
    }
    EventBus.$on('openRender', (welcome) => {
      if (welcome) {
        this.tourIndex = -1;
        this.playNextTour();
      } else {
        $('#modal_dashboard').modal({
          backdrop: 'static',
          keyboard: false
        });
        $('#modal_accounts').modal('hide');
        EventBus.$emit('closeDrpDwnAccount');
        this.tourIndex = this.tourObject.length - 1;
        this.currentTour = this.tourObject[this.tourIndex];
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
